import useSharedQueryPoller from './useSharedQueryPoller';

export default useSharedQueryPoller;
